import * as React from "react";

import {
    List,
    TopToolbar,
    EditButton,
    ExportButton,
    TextInput,
    Datagrid,
    TextField,
    FilterButton,
    SearchInput,
   
} from "react-admin";


const ListActions = (props) => (
    <TopToolbar>
        <FilterButton />
        <ExportButton />
    </TopToolbar>
);

const operationFilters = [<SearchInput  source="zipcode" alwaysOn />, <TextInput label="User Name" source="user_id" />];


export const OperationList = (props) => (
    <List {...props} filters={operationFilters} filter actions={<ListActions />}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="zipcode" />
            <TextField source="radius" />
            <TextField source="user_name" />
            <EditButton />
        </Datagrid>
    </List>
);